<template>
  <div v-show="visible" :class="classes" v-on="$listeners">
    <slot />
  </div>
</template>

<script>
import classes from '~~/common/vue/mixins/classes';

export const sides = ['left', 'right'];

export default {
  name: 'EDropdown',
  mixins: [classes],
  props: {
    /**
     * The side for the dropdown `left, right`
     */
    side: {
      type: String,
      default: 'left',
      validator: (value) => sides.includes(value),
      cssClass: true,
    },
    /**
     * The visibility for the dropdown
     */
    visible: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown {
  @include elevation(2);

  position: absolute;
  top: 100%;
  min-width: 184px;
  background-color: $white;
  border-radius: $border-radius-s;
  z-index: $z-index-1l;

  &--side-left {
    left: 0;
  }

  &--side-right {
    right: $space-s;
  }
}
</style>

<docs>
```js
<div style="position: relative;">
  Toggle
  <EDropdown :visible="true">
    test
  </EDropdown>
</div>
```
</docs>
